import * as actionNames from '../actionNames';

export const selectNews = (newsObject) => ({
    type: actionNames.SELECT_NEWS,
    newsObject: newsObject   
})


